import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { Component } from 'react';
import PropTypes from 'prop-types';
import { attempt } from 'lodash-es';
import { findIndex } from 'lodash-es';
import { getEventsConfig } from 'react-jsx-highcharts';

var RangeSelectorButton =
/*#__PURE__*/
function (_Component) {
  _inherits(RangeSelectorButton, _Component);

  function RangeSelectorButton() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, RangeSelectorButton);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(RangeSelectorButton)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "getButtons", function () {
      var chartObj = _this.props.getChart().object;

      if (chartObj && chartObj.options) {
        var _chartObj$options$ran = chartObj.options.rangeSelector.buttons,
            buttons = _chartObj$options$ran === void 0 ? [] : _chartObj$options$ran;
        return buttons;
      }

      return [];
    });

    _defineProperty(_assertThisInitialized(_this), "getButtonIndex", function () {
      var _this$props = _this.props,
          count = _this$props.count,
          type = _this$props.type;
      return findIndex(_this.getButtons(), function (b) {
        return b.count === count && b.type === type;
      });
    });

    _defineProperty(_assertThisInitialized(_this), "addButton", function (config) {
      // Add button to array
      var buttons = [].concat(_toConsumableArray(_this.getButtons()), [config]);

      _this.updateRangeSelectorButtons(buttons);
    });

    _defineProperty(_assertThisInitialized(_this), "removeButton", function () {
      var button = _this.getButtonIndex();

      if (button === -1) return; // Remove button from array

      var buttons = _toConsumableArray(_this.getButtons());

      buttons.splice(button, 1);

      _this.updateRangeSelectorButtons(buttons);
    });

    _defineProperty(_assertThisInitialized(_this), "updateRangeSelectorButtons", function (config) {
      var chart = _this.props.getChart();

      chart.update({
        rangeSelector: {
          buttons: config
        }
      });
    });

    return _this;
  }

  _createClass(RangeSelectorButton, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var button = this.getButtonIndex();
      if (button > -1) return; // Button already present

      var _this$props2 = this.props,
          count = _this$props2.count,
          type = _this$props2.type,
          offsetMin = _this$props2.offsetMin,
          offsetMax = _this$props2.offsetMax,
          dataGrouping = _this$props2.dataGrouping,
          text = _this$props2.children,
          rest = _objectWithoutProperties(_this$props2, ["count", "type", "offsetMin", "offsetMax", "dataGrouping", "children"]);

      var opts = {
        count: count,
        type: type,
        offsetMin: offsetMin,
        offsetMax: offsetMax,
        dataGrouping: dataGrouping,
        text: text,
        events: getEventsConfig(rest)
      };
      this.addButton(opts);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      attempt(this.removeButton);
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return RangeSelectorButton;
}(Component);

_defineProperty(RangeSelectorButton, "defaultProps", {
  count: 1,
  offsetMin: 0,
  offsetMax: 0
});

export default RangeSelectorButton;